import structureTypes from 'common/constants/structureTypes'
import EntityTypeEnum from 'common/enums/entityTypeEnum'

const defaultRow = {
  [EntityTypeEnum.Row]: {
    children: [
      {
        [EntityTypeEnum.Column]: {},
      },
    ],
  },
}

const defaultScheme = {
  [structureTypes.BODY]: {
    children: [
      {
        [EntityTypeEnum.Section]: {
          children: [defaultRow],
        },
      },
    ],
  },
  [EntityTypeEnum.Body]: {
    children: [
      {
        [EntityTypeEnum.Section]: {
          children: [defaultRow],
        },
      },
    ],
  },
  [structureTypes.BLOG_POST_BODY]: {
    children: [
      {
        [EntityTypeEnum.Section]: {
          children: [defaultRow],
        },
      },
    ],
  },
  [EntityTypeEnum.BlogPostBody]: {
    children: [
      {
        [EntityTypeEnum.Section]: {
          children: [defaultRow],
        },
      },
    ],
  },
  [structureTypes.BLOG_POST_LAYOUT_BODY]: {
    children: [
      {
        [EntityTypeEnum.Section]: {
          children: [defaultRow],
        },
      },
    ],
  },
  [EntityTypeEnum.BlogPostLayoutBody]: {
    children: [
      {
        [EntityTypeEnum.Section]: {
          children: [defaultRow],
        },
      },
    ],
  },
  [structureTypes.BLOG_PAGE_BODY]: {
    children: [
      {
        [EntityTypeEnum.Section]: {
          children: [defaultRow],
        },
      },
    ],
  },
  [EntityTypeEnum.BlogPageBody]: {
    children: [
      {
        [EntityTypeEnum.Section]: {
          children: [defaultRow],
        },
      },
    ],
  },
  [EntityTypeEnum.Section]: {
    children: [defaultRow],
  },
  [structureTypes.SECTION]: {
    children: [defaultRow],
  },
  [EntityTypeEnum.Row]: {
    children: [
      {
        [EntityTypeEnum.Column]: {},
      },
    ],
  },
  [EntityTypeEnum.Column]: {
    children: [],
  },
  [structureTypes.ROW]: {
    children: [
      {
        [structureTypes.COLUMN_12]: {},
      },
    ],
  },
  [structureTypes.COLUMN]: {
    children: [],
  },
  [EntityTypeEnum.RemotePopupBody]: {
    children: [defaultRow],
  },
  [EntityTypeEnum.InlineBody]: {
    children: [defaultRow],
  },
  [structureTypes.CONTENT_BOX]: {
    children: [],
  },
  [EntityTypeEnum.ContentBox]: {
    children: [],
  },
  [EntityTypeEnum.FaqItem]: {
    children: [],
  },
  [EntityTypeEnum.CarouselItem]: {
    children: [],
  },
  [EntityTypeEnum.ContactUs]: {
    children: [defaultRow],
  },
  [EntityTypeEnum.Image]: {
    children: [],
  },
  [structureTypes.FORM_INPUT]: structureTypes.FORM_INPUT,
  [structureTypes.BUTTON]: structureTypes.BUTTON,
  [EntityTypeEnum.TwoStepPaymentFormStepOptIn]: {
    children: [defaultRow],
  },
  [EntityTypeEnum.TwoStepPaymentFormStepPayment]: {
    children: [defaultRow],
  },
}

export default defaultScheme
